import React, { useEffect, useState } from "react";
import {
  Button,
  ButtonToolbar,
  Form,
  Loader,
  Container,
  Content,
  Modal,
} from "rsuite";
import { CommercialServices } from "../../../core/services/CommercialServices";
import { UtilityServices } from "../../../core/services/UtilityServices";
import "./Commercials.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { displayField, processSecond } from "../../../utils/helpers";

const ViewCommercialModal = (props: any) => {
  const { t } = useTranslation();
  const commercialViewId = useSelector((state: any) => {
    return state?.actionData?.id;
  });
  const [loader, setLoader] = useState(false);
  const [commercialInfo, setCommercialInfo] = useState<any>({});
  async function getViewCommercialDetail(id: number) {
    try {
      setLoader(true);
      const res = await CommercialServices.viewCommercial(id);
      setLoader(false);
      if (res && res.data && res.data.data) {
        setCommercialInfo({ ...res.data.data });
      }
    } catch (error) {
      setLoader(false);
    }
  }
  useEffect(() => {
    getViewCommercialDetail(commercialViewId);
  }, []);

  return (
    <div className="modal-container">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      <Modal
        open={props.status}
        backdrop={false}
        onClose={(e: any) => {
          props.toggle("");
        }}
      >
        <Modal.Header>
          <h4 className="text-center">
            {t("VIEW")} {t("DETAIL")}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <div className="commercials">
            <Container className="container">
              {commercialInfo && Object.keys(commercialInfo).length ? (
                <Content>
                  <Form layout="inline">
                    <div style={{ width: "200px" }}>
                      <div>
                        <img
                          style={{
                            borderRadius: "100%",
                            width: 100,
                            height: 100,
                            border: "1px solid black",
                          }}
                          src={
                            commercialInfo && commercialInfo?.media_image_url
                              ? commercialInfo.media_image_url
                              : UtilityServices.getLoggedInUser(
                                  "commercial_default_image"
                                )
                          }
                          alt=""
                        />{" "}
                        {processSecond(commercialInfo?.media_duration)}
                      </div>
                    </div>
                    <Form.Group controlId="title">
                      <Form.ControlLabel>
                        {t("COMMERCIAL")} {t("NAME")}:
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${commercialInfo?.title}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="media_nature">
                      <Form.ControlLabel>{t("TYPE")} :</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${commercialInfo?.media_nature}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="brand_name">
                      <Form.ControlLabel>{t("BRAND")} : </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${commercialInfo?.brand_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="campaign_name">
                      <Form.ControlLabel>{t("CAMPAIGN")} : </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${commercialInfo?.campaign_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="sourced_from">
                      <Form.ControlLabel>
                        {t("SOURCED")} {t("FROM")} :{" "}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${commercialInfo?.sourced_from}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                  </Form>
                </Content>
              ) : null}
            </Container>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ViewCommercialModal;
